import { render, staticRenderFns } from "./_navItems.vue?vue&type=template&id=82a03e2c&"
import script from "./_navItems.vue?vue&type=script&lang=js&"
export * from "./_navItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports